import domToReact from 'html-react-parser/lib/dom-to-react'
import React from 'react'
import { Helmet } from 'react-helmet'

const embedExternal = ({ domNode }) => {
  const { attribs, children } = domNode
  if (attribs.class === 'embed-box') {
    const embedBoxChildren = children
    if (embedBoxChildren) {
      let scriptElements = []
      let loadPinpoll = false
      let loadApa = false

      for (let childKey in embedBoxChildren) {
        if (embedBoxChildren[childKey].name === 'script') {
          const scriptElement = embedBoxChildren[childKey]
          const scriptSrc = scriptElement.attribs.src

          if (scriptSrc) {
            scriptElements.push(<script key={childKey} src={scriptSrc} {...scriptElement.attribs}></script>)
          }
          if (!scriptSrc) {
            scriptElements.push(<script key={childKey}>{domToReact(scriptElement.children)}</script>)
          }
        } else if (embedBoxChildren[childKey].name === 'div') {
          if (embedBoxChildren[childKey].attribs.hasOwnProperty('data-pinpoll-id')) {
            loadPinpoll = true
          } else {
            for (let grandchildKey in embedBoxChildren[childKey].children) {
              let grandchild = embedBoxChildren[childKey].children[grandchildKey]
              if (grandchild.name == 'iframe') {
                if (grandchild.attribs.src.startsWith('https://uvp-athesia.sf.apa.at/embed/')) {
                  loadApa = true
                }
              }
            }
          }
        }
      }

      if (loadPinpoll) {
        scriptElements.push(<script key="pinpoll_script" src="https://tools.pinpoll.com/global.js" async />)
      }
      if (loadApa) {
        scriptElements.push(
          <script key="apa-script" type="text/javascript">{`
          function apa_doc_ready(fn) {
            if (document.readyState != 'loading') {
              fn();
            } else {
              document.addEventListener('DOMContentLoaded', fn);
            }
          }

          function apa_set_consent(gdpr, gdpr_consent) {
            var elements = document.querySelectorAll('.apavideo');
            Array.prototype.forEach.call(elements, function(el, i) {
              var url = el.getAttribute('data-src');
              if (url) {
                if (url.indexOf("?") >= 0) {
                  url = url + "&";
                } else {
                  url = url + "?";
                }
                var newurl = url + "ad_gdpr=" + gdpr + "&ad_gdpr_consent=" + gdpr_consent;
                el.setAttribute('src', newurl);
              }
            });
          }
          apa_doc_ready(
            function() {
              const __tcfapi = window.__tcfapi

              if (!__tcfapi) {
                return false
              }

              __tcfapi('getTCData', 2, (tcData, success) => {
                if (success) {
                  console.log("GDPR startet, consent: " + tcData.tcString);
                  var gdpr = "1";
                  var gdpr_consent = tcData.tcString;
                  apa_set_consent(gdpr, gdpr_consent);
                }
              })
            });
        `}</script>,
        )
      }

      return (
        <React.Fragment>
          <Helmet>{scriptElements}</Helmet>
          {domToReact(embedBoxChildren)}
        </React.Fragment>
      )
    }
  }
}

export default embedExternal
